import entityValidatorResult from "../../Entity/validatorResult";

const ValidatorInputText = (value, plausi) => {

  if (!plausi) {
    return entityValidatorResult(true);
  }

  var result = entityValidatorResult();

  if (plausi.hasOwnProperty("required")) {
    pusher(
      result.message,
      valRequired(value, plausi.required)
    )
  }

  if (plausi.hasOwnProperty('empty')) {
    pusher(
      result.message,
      valEmpty(value, plausi.empty)
    )
  }

  if (plausi.hasOwnProperty("min")) {
    pusher(
      result.message,
      valMin(value, plausi.min, plausi.empty)
    )
  }

  if (plausi.hasOwnProperty("max")) {
    pusher(
      result.message,
      valMax(value, plausi.max, plausi.empty)
    )
  }

  if (plausi.hasOwnProperty("number")) {
    pusher(
      result.message,
      valNumber(value, plausi.number)
    )
  }

  result.valid = (result.message.length < 1)

  return result;

}

const pusher = (msg, value) => {
  if (value) {
    msg.push(value)
  }
}

const valRequired = (value, required) => {
  if ( !value && required===true ) {
    return 'Angabe ist erforderlich.';
  }
  return "";
}

const valEmpty = (value, empty) => {
  if ( value.length < 1 && empty===false ) {
    return 'Feld darf nicht leer sein.';
  }
  return "";
}

const valMin = (value, min, empty) => {
  if ( value.length < 1 && empty===true ) {
    return '';
  }

  if ( value.length >= min) {
    return '';
  }

  return 'Feld muss mindestens '+min+' Zeichen enthalten.'

}

const valMax = (value, max) => {

  if (max === null) {
    return ""
  }

  if ( value.length <= max) {
    return ''
  }

  return 'Feld darf maximal '+max+' Zeichen enthalten.'

}

const valNumber = (value, shouldBeNumber) => {

  if ( shouldBeNumber !== true) {
    return '';
  }

  if ( value.length < 1) {
    return '';
  }

  if ( /^\d+$/.test(value) ) {
    return '';
  }

  return 'Feld darf nur Zahlen enthalten.';

}


export default ValidatorInputText;
